<template>
    <div>
        <Row>
            <Col span="24">
            <Collapse v-model="value1" size="small" @on-change="setstatus" ref="topResult">
                <Panel id="panelTop1" name="1" size="small" class="cpllapse-panel-title">
                    检索结果
                    <div slot="content">
                        <div :style="{display:searchDefaultDisp?'block':'none'}">空空如也~~~&nbsp;&nbsp;&nbsp;<Button type="primary" size="small" @click="goSearchEngine">尝试综合检索</Button>
                        </div>
                        <NextSearchBar :style="{display:isGeneralNextBarShow?'block':'none'}" ref="complexNextSearchBar" :isHidden="false" @next-search="complexNextSearch"></NextSearchBar>

                        <SearchResult ref="general_search_rlt" @onPageChange="pageChange" :tData="rData" :style="{display:singleProvision?'block':'none'}" @selectUpload-checked="tableRowChecked"></SearchResult>
                        <div :style="{display:singleProvision?'block':'none',height:'5px',lineHeight:'5px'}" />
                        <div v-if="flag">
                            <ResultTag ref="generalTag" :style="{display:singleProvision?'block':'none'}" :sTreeData="tagData" :sTreeIndustry="sTreeIndustry" :streeProvince="streeProvince" :isSearchEngine=true @onTagchanged="childTagChange" @on-show-checkbox="showChkBox" @clean-checked="clearCheckList" @on-submit-checked="onGeneralSubmitChecked" @on-tips-close="tagGeneralTipsClose" @on-one-key-upload="onGeneralOneKeyUpload" @on-folder-selected-upload="onGeneralSelectedUploadReady" @set-tagpc="generalLayerChange"></ResultTag>
                        </div>


                        <!--   <br style="{display:singleProvision?'block':'none'}" /> -->
                        <Tabs id="searchMainTabs" size="default" :style="{display:doubleProvision?'block':'none'}">
                            <TabPane label="通用规定">
                                <div>
                                    <NextSearchBar :style="{display:isCommonNextBarShow?'block':'none'}" ref="commonNextSearchBar" :isHidden="false" @next-search="commonNextSearch"></NextSearchBar>
                                    <SearchResult ref="search_rlt_common" @onPageChange="pageChange" :tData="tData" @selectUpload-checked="tableCommonRowChecked"></SearchResult>
                                    <div v-if="isShowCommonTag">
                                        <ResultTag ref="tableTag_common" :style="{display:doubleProvision?'block':'none'}" :sTreeData="tagCommonData" :sTreeIndustry="sTreeIndustry" :streeProvince="streeProvince" :isSearchEngine=true @onTagchanged="childCommondTagChange" @on-show-checkbox="showCommonTableChkBox" @clean-checked="clearCommonCheckList" @on-submit-checked="onCommonSubmitChecked" @on-one-key-upload="onCommonOneKeyUpload" @on-folder-selected-upload="onCommonSelectedUploadReady" @set-tagpc="commonLayerChange"></ResultTag>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane :label="specialTagName">
                                <div>
                                    <NextSearchBar :style="{display:isSpecialNextBarShow?'block':'none'}" ref="specialNextSearchBar" :isHidden="false" @next-search="specialNextSearch"></NextSearchBar>
                                    <SearchResult ref="search_rlt_special" @onPageChange="pageChange" :tData="tData2" @selectUpload-checked="tableSpecialRowChecked"></SearchResult>
                                    <div v-if="isShowSpecialTag">
                                        <ResultTag ref="tableTag_special" :style="{display:doubleProvision?'block':'none'}" :sTreeData="tagSpecialData" :sTreeIndustry="sTreeIndustry" :streeProvince="streeProvince" :isSearchEngine=true @onTagchanged="childSpecialTagChange" @on-show-checkbox="showSpecialChkBox" @clean-checked="clearSpecialCheckList" @on-submit-checked="onSpecialSubmitChecked" @on-one-key-upload="onSpecialOneKeyUpload" @on-folder-selected-upload="onSpecialSelectedUploadReady" @set-tagpc="specialLayerChange"></ResultTag>
                                    </div>
                                </div>
                            </TabPane>
                        </Tabs>
                        
                        <!-- <Collapse v-model="value2" size="small" @on-change="setstatus" :style="{display:doubleProvision?'block':'none'}">
                            <Panel name="1" size="small" class="cpllapse-panel-title" :style="{display:commonProvision?'block':'none'}">
                                通用规定
                                <div slot="content">
                                    <NextSearchBar :style="{display:isCommonNextBarShow?'block':'none'}" ref="commonNextSearchBar" :isHidden="false" @next-search="commonNextSearch"></NextSearchBar>
                                    <SearchResult ref="search_rlt_common" @onPageChange="pageChange" :tData="tData" @selectUpload-checked="tableCommonRowChecked"></SearchResult>
                                    <div v-if="isShowCommonTag">
                                        <ResultTag ref="tableTag_common" :style="{display:doubleProvision?'block':'none'}" :sTreeData="tagCommonData" :sTreeIndustry="sTreeIndustry" :streeProvince="streeProvince" :isSearchEngine=true @onTagchanged="childCommondTagChange" @on-show-checkbox="showCommonTableChkBox" @clean-checked="clearCommonCheckList" @on-submit-checked="onCommonSubmitChecked" @on-one-key-upload="onCommonOneKeyUpload" @on-folder-selected-upload="onCommonSelectedUploadReady" @set-tagpc="commonLayerChange"></ResultTag>
                                    </div>
                                </div>
                            </Panel>
                            <Panel name="2" size="small" class="cpllapse-panel-title" :style="{display:specialProvision?'block':'none'}">
                                {{specialTagName}}
                                <div slot="content">
                                    <NextSearchBar :style="{display:isSpecialNextBarShow?'block':'none'}" ref="specialNextSearchBar" :isHidden="false" @next-search="specialNextSearch"></NextSearchBar>
                                    <SearchResult ref="search_rlt_special" @onPageChange="pageChange" :tData="tData2" @selectUpload-checked="tableSpecialRowChecked"></SearchResult>
                                    <div v-if="isShowSpecialTag">
                                        <ResultTag ref="tableTag_special" :style="{display:doubleProvision?'block':'none'}" :sTreeData="tagSpecialData" :sTreeIndustry="sTreeIndustry" :streeProvince="streeProvince" :isSearchEngine=true @onTagchanged="childSpecialTagChange" @on-show-checkbox="showSpecialChkBox" @clean-checked="clearSpecialCheckList" @on-submit-checked="onSpecialSubmitChecked" @on-one-key-upload="onSpecialOneKeyUpload" @on-folder-selected-upload="onSpecialSelectedUploadReady" @set-tagpc="specialLayerChange"></ResultTag>
                                    </div>
                                </div>
                            </Panel>
                        </Collapse> -->


                    </div>
                </Panel>
                <Panel name="5" size="small" class="cpllapse-panel-title">
                    综合检索
                    <div slot="content">
                        <globalEngine @onGlobalSearch="onGlobalSearch"></globalEngine>
                    </div>
                </Panel>
                <Panel name="2" size="small" class="cpllapse-panel-title">
                    行业检索
                    <div slot="content">
                        <SearchEngine @onEngineSearch="onSearch"></SearchEngine>
                    </div>
                </Panel>
                <Panel name="6" size="small" class="cpllapse-panel-title">
                    税收优惠检索
                    <div slot="content">
                        <TaxBreak @onTaxBreakSearch="onTaxBreakSearch"></TaxBreak>
                    </div>
                </Panel>
                <Panel name="3" size="small" class="cpllapse-panel-title">
                    条约检索
                    <div slot="content">
                        <treatyEngine ref="treatengine01" @onTreatySearch="onTreatySearch"></treatyEngine>
                    </div>
                </Panel>
                <Panel name="4" size="small" class="cpllapse-panel-title">
                    进出口税收检索
                    <div slot="content">
                        <TradeEngine @onTradeSearch="onTradeSearch"></TradeEngine>
                    </div>
                </Panel>
            </Collapse>
            </Col>
        </Row>
        <br />
        <!-- <Button>
      <router-link to="/main/identical/myidentical">涉税同名文件查询系统</router-link>
    </Button> -->
        <Modal v-model="isShowProgressBox" @on-ok="onProgressOK" @on-cancel="onProgressCancel" :mask-closable="false" :closable="false">
            <p slot="header" :style="{color:titletheme}" style="text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{uploadTitle}}</span>
            </p>
            <div><Progress :percent="uploadpercent" :stroke-width="20" status="active" text-inside /></div>
            <div slot="footer">
                <Button :type="buttonTheme" :disabled="isActiveButton" size="large" @click="onProgressOK">{{progressBoxButtonText}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import tableresult from './resulttable.vue'
import SearchEngine from './searchengine.vue'
import treatyEngine from './treatyengine.vue'
import ForeignTrade from './foreign_trade.vue'
import TaxBreak from './taxBreak.vue'
import globalEngine from './globalengine.vue'
import nextSearchBar from './nextSearchBar.vue'
import ResultTag from '../common_engine/resultTag.vue'
import tableData from '../../../assets/json/tabledata.json'
import testData from '../../../assets/json/testTableData.json'
import testData2 from '../../../assets/json/testTableData2.json'
import TagCityData from '../../../assets/json/tagCity.json'
import moment from 'moment'
import More from "../../../api/common/more.js"
import ConstJson from "../../../api/common/constjson.js"
import { mapGetters } from 'vuex'
let MoreFun = new More()
let constJ = new ConstJson()
export default {
    name: "searchEngineMain",
    // props:[""],
    inject: ["reload", "getSliders"],
    data() {
        return {
            psize:8,
            value1: ["1"],
            value2: [],
            classid: "",
            //isNextSearchDisp:false,
            searchDefaultDisp: true,
            specialProvision: true,
            commonProvision: true,
            doubleProvision: false,
            singleProvision: false,
            tData: this.getSpecialProvisionData(),
            tData2: this.getSpecialProvisionData2(),
            rData: {}, //this.getTableData(),
            formCommonSearch: {},
            formSearchData: {}, //提交给接口的数据
            userSearchData: {
                industry: {
                    common_da: [],
                    common_text2: "",
                    special_da: [],
                    special_text2: ""
                },
                treaty: {
                    common_da: [],
                    common_text2: "",
                    special_da: [],
                    special_text2: ""
                },
                industrytaxbreak: {
                    common_da: [],
                    common_text2: "",
                    special_da: [],
                    special_text2: ""
                },
            }, //用户在不同搜索引擎中输入的查询条件
            //tag
            flag: false,
            defaultTagpc: {
                general: [{ p: '000000', c: '000000' }],
                common: [{ p: '000000', c: '000000' }],
                special: [{ p: '000000', c: '000000' }],
            },
            tagpc: {
                general: [],
                common: [],
                special: [],
            },
            defaultpc: {
                p: "510100",
                c: "000000",
            },
            tagData: {}, //综合查询tag数据 //this.getTreeData(),
            tagCommonData: {}, //通用tag
            tagSpecialData: {}, //专属tag
            isShowCommonTag: false,
            isShowSpecialTag: false,
            sTreeIndustry: this.getIndustryData(0),
            streeProvince: this.getProvince(),
            currentNode: {},
            searchType: 0, //1-综合,2-行业,3-条约,4-进出口,5-税收优惠项目,6-税收优惠税种,7-税收优惠行业
            specialTagName: "",
            selectNode: {
                complexNode: {},
                industryCommonNode: {},
                industrySpecialNode: {},
                treatyCommonNode: {},
                treatySpecialNode: {},
                taxBreakNode_item: {},
                taxBreakNode_taxes: {},
                tradeNode: {},
                industrytaxBreakCommonNode: {},
                industrytaxBreakSpecialNode: {},
            },
            sliders: this.getSliders(),
            isGeneralNextBarShow: true,
            isCommonNextBarShow: true,
            isSpecialNextBarShow: true,
            isShowProgressBox: false, //上传对话框
            uploadpercent: 0, //上传进度
            isPollingStop: false, //暂停轮询
            uploadTitle: '稍候片刻,请静待上传完成', //提示信息
            titletheme: '#2d8cf0', //提示信息颜色
            errorStatus: '', //错误状态
            progressBoxButtonText: '确定', //确定按钮文字
            isActiveButton: true, //是否禁用按钮
            buttonTheme: 'success', //按钮样式
            disconnectTimes: 0, //网络连接失败，20次后进度条按钮可以关闭
            isFirstSearch: false,
            isFilter: false,
            isFirstSearch_Common: false,
            isFirstSearch_Special: false,
            isFilter_Common: false,
            isFilter_Special: false,

        }
    },
    provide() {
        return {
            expand: this.expand
        }
    },
    computed: {
        ...mapGetters(['getVersion'])
    },
    components: {
        'SearchResult': tableresult,
        'SearchEngine': SearchEngine,
        'treatyEngine': treatyEngine,
        'TradeEngine': ForeignTrade,
        'GlobalEngine': globalEngine,
        'ResultTag': ResultTag,
        'NextSearchBar': nextSearchBar,
        'TaxBreak': TaxBreak,
    },
    methods: {
        // showDialog2() {
        //     let that = this
        //     this.$Modal.confirm({
        //         title: '提示',
        //         //content: '<p>' + content + '</p>',
        //         render: h => {
        //             return h('span', [
        //                 '',
        //                 h('span', {
        //                     domProps: {
        //                         innerHTML: `<span style="color:#515a6e;font-size:14px;" >关闭一键上传进度显示,系统仍然会持续完成文件上传任务，确认关闭吗?</span>`,
        //                     }
        //                 }), ''
        //             ])
        //         },
        //         okText: '确认',
        //         cancelText: '取消',
        //         onOk: () => {
        //             this.isPollingStop = true
        //             this.isShowProgressBox = false
        //         },
        //         onCancel: () => {
        //             if (this.uploadpercent === 100 || this.isPollingStop) {
        //                 this.isShowProgressBox = false
        //             } else {
        //                 this.isShowProgressBox = true
        //             }
        //             return
        //             // this.$Message.info('Clicked cancel');
        //         }
        //     });
        // },

        ////1-综合,2-行业,3-条约,4-进出口,5-税收优惠项目,6-税收优惠税种,7-税收优惠行业
        ////t:common/special
        setDefaultTagId(t) {
            switch (this.searchType) {
                case 1:
                    //综合
                    if (this.selectNode.complexNode.id === undefined) {
                        //计算默认的tagid
                        if (this.tagData.status.minlock === 1) {
                            this.selectNode.complexNode.id = this.tagData.tags.t1[0].id
                        } else if (this.tagData.status.minlock === 2) {
                            this.selectNode.complexNode.id = this.tagData.tags.t2[0].id
                        } else if (this.tagData.status.minlock === 3) {
                            this.selectNode.complexNode.id = this.tagData.tags.t3[0].id
                        } else if (this.tagData.status.minlock === 4) {
                            this.selectNode.complexNode.id = this.tagData.tags.t4[0].id
                        } else if (this.tagData.status.minlock === 5) {
                            this.selectNode.complexNode.id = this.tagData.tags.t5[0].id
                        }
                    }
                    break;
                case 2:
                    //行业
                    if (t === "common") {
                        if (this.selectNode.industryCommonNode.id === undefined) {
                            //计算默认的tagid
                            if (this.tagCommonData.status.minlock === 1) {
                                this.selectNode.industryCommonNode.id = this.tagCommonData.tags.t1[0].id
                            } else if (this.tagCommonData.status.minlock === 2) {
                                this.selectNode.industryCommonNode.id = this.tagCommonData.tags.t2[0].id
                            } else if (this.tagCommonData.status.minlock === 3) {
                                this.selectNode.industryCommonNode.id = this.tagCommonData.tags.t3[0].id
                            } else if (this.tagCommonData.status.minlock === 4) {
                                this.selectNode.industryCommonNode.id = this.tagCommonData.tags.t4[0].id
                            } else if (this.tagCommonData.status.minlock === 5) {
                                this.selectNode.industryCommonNode.id = this.tagCommonData.tags.t5[0].id
                            }
                        }
                    }
                    if (t === "special") {
                        if (this.selectNode.industrySpecialNode.id === undefined) {
                            //计算默认的tagid
                            if (this.tagSpecialData.status.minlock === 1) {
                                this.selectNode.industrySpecialNode.id = this.tagSpecialData.tags.t1[0].id
                            } else if (this.tagSpecialData.status.minlock === 2) {
                                this.selectNode.industrySpecialNode.id = this.tagSpecialData.tags.t2[0].id
                            } else if (this.tagSpecialData.status.minlock === 3) {
                                this.selectNode.industrySpecialNode.id = this.tagSpecialData.tags.t3[0].id
                            } else if (this.tagSpecialData.status.minlock === 4) {
                                this.selectNode.industrySpecialNode.id = this.tagSpecialData.tags.t4[0].id
                            } else if (this.tagSpecialData.status.minlock === 5) {
                                this.selectNode.industrySpecialNode.id = this.tagSpecialData.tags.t5[0].id
                            }
                        }
                    }
                    break;
                case 3:
                    //条约
                    if (t === "common") {
                        if (this.selectNode.treatyCommonNode.id === undefined) {
                            //计算默认的tagid
                            if (this.tagCommonData.status.minlock === 1) {
                                this.selectNode.treatyCommonNode.id = this.tagCommonData.tags.t1[0].id
                            } else if (this.tagCommonData.status.minlock === 2) {
                                this.selectNode.treatyCommonNode.id = this.tagCommonData.tags.t2[0].id
                            } else if (this.tagCommonData.status.minlock === 3) {
                                this.selectNode.treatyCommonNode.id = this.tagCommonData.tags.t3[0].id
                            } else if (this.tagCommonData.status.minlock === 4) {
                                this.selectNode.treatyCommonNode.id = this.tagCommonData.tags.t4[0].id
                            } else if (this.tagCommonData.status.minlock === 5) {
                                this.selectNode.treatyCommonNode.id = this.tagCommonData.tags.t5[0].id
                            }
                        }
                    }
                    if (t === "special") {
                        if (this.selectNode.treatySpecialNode.id === undefined) {
                            //计算默认的tagid
                            if (this.tagSpecialData.status.minlock === 1) {
                                this.selectNode.treatySpecialNode.id = this.tagSpecialData.tags.t1[0].id
                            } else if (this.tagSpecialData.status.minlock === 2) {
                                this.selectNode.treatySpecialNode.id = this.tagSpecialData.tags.t2[0].id
                            } else if (this.tagSpecialData.status.minlock === 3) {
                                this.selectNode.treatySpecialNode.id = this.tagSpecialData.tags.t3[0].id
                            } else if (this.tagSpecialData.status.minlock === 4) {
                                this.selectNode.treatySpecialNode.id = this.tagSpecialData.tags.t4[0].id
                            } else if (this.tagSpecialData.status.minlock === 5) {
                                this.selectNode.treatySpecialNode.id = this.tagSpecialData.tags.t5[0].id
                            }
                        }
                    }
                    break;
                case 4:
                    //进出口
                    if (this.selectNode.tradeNode.id === undefined) {
                        //计算默认的tagid
                        if (this.tagData.status.minlock === 1) {
                            this.selectNode.tradeNode.id = this.tagData.tags.t1[0].id
                        } else if (this.tagData.status.minlock === 2) {
                            this.selectNode.tradeNode.id = this.tagData.tags.t2[0].id
                        } else if (this.tagData.status.minlock === 3) {
                            this.selectNode.tradeNode.id = this.tagData.tags.t3[0].id
                        } else if (this.tagData.status.minlock === 4) {
                            this.selectNode.tradeNode.id = this.tagData.tags.t4[0].id
                        } else if (this.tagData.status.minlock === 5) {
                            this.selectNode.tradeNode.id = this.tagData.tags.t5[0].id
                        }
                    }
                    break;
                case 5:
                    //税收优惠项目
                    if (this.selectNode.taxBreakNode_item.id === undefined) {
                        //计算默认的tagid
                        if (this.tagData.status.minlock === 1) {
                            this.selectNode.taxBreakNode_item.id = this.tagData.tags.t1[0].id
                        } else if (this.tagData.status.minlock === 2) {
                            this.selectNode.taxBreakNode_item.id = this.tagData.tags.t2[0].id
                        } else if (this.tagData.status.minlock === 3) {
                            this.selectNode.taxBreakNode_item.id = this.tagData.tags.t3[0].id
                        } else if (this.tagData.status.minlock === 4) {
                            this.selectNode.taxBreakNode_item.id = this.tagData.tags.t4[0].id
                        } else if (this.tagData.status.minlock === 5) {
                            this.selectNode.taxBreakNode_item.id = this.tagData.tags.t5[0].id
                        }
                    }
                    break;
                case 6:
                    //税收优惠税种
                    if (this.selectNode.taxBreakNode_taxes.id === undefined) {
                        //计算默认的tagid
                        if (this.tagData.status.minlock === 1) {
                            this.selectNode.taxBreakNode_taxes.id = this.tagData.tags.t1[0].id
                        } else if (this.tagData.status.minlock === 2) {
                            this.selectNode.taxBreakNode_taxes.id = this.tagData.tags.t2[0].id
                        } else if (this.tagData.status.minlock === 3) {
                            this.selectNode.taxBreakNode_taxes.id = this.tagData.tags.t3[0].id
                        } else if (this.tagData.status.minlock === 4) {
                            this.selectNode.taxBreakNode_taxes.id = this.tagData.tags.t4[0].id
                        } else if (this.tagData.status.minlock === 5) {
                            this.selectNode.taxBreakNode_taxes.id = this.tagData.tags.t5[0].id
                        }
                    }
                    break;
                case 7:
                    //税收优惠行业
                    if (t === "common") {
                        if (this.selectNode.industrytaxBreakCommonNode.id === undefined) {
                            //计算默认的tagid
                            if (this.tagCommonData.status.minlock === 1) {
                                this.selectNode.industrytaxBreakCommonNode.id = this.tagCommonData.tags.t1[0].id
                            } else if (this.tagCommonData.status.minlock === 2) {
                                this.selectNode.industrytaxBreakCommonNode.id = this.tagCommonData.tags.t2[0].id
                            } else if (this.tagCommonData.status.minlock === 3) {
                                this.selectNode.industrytaxBreakCommonNode.id = this.tagCommonData.tags.t3[0].id
                            } else if (this.tagCommonData.status.minlock === 4) {
                                this.selectNode.industrytaxBreakCommonNode.id = this.tagCommonData.tags.t4[0].id
                            } else if (this.tagCommonData.status.minlock === 5) {
                                this.selectNode.industrytaxBreakCommonNode.id = this.tagCommonData.tags.t5[0].id
                            }
                        }
                    }
                    if (t === "special") {
                        if (this.selectNode.industrytaxBreakSpecialNode.id === undefined) {
                            //计算默认的tagid
                            if (this.tagSpecialData.status.minlock === 1) {
                                this.selectNode.industrytaxBreakSpecialNode.id = this.tagSpecialData.tags.t1[0].id
                            } else if (this.tagSpecialData.status.minlock === 2) {
                                this.selectNode.industrytaxBreakSpecialNode.id = this.tagSpecialData.tags.t2[0].id
                            } else if (this.tagSpecialData.status.minlock === 3) {
                                this.selectNode.industrytaxBreakSpecialNode.id = this.tagSpecialData.tags.t3[0].id
                            } else if (this.tagSpecialData.status.minlock === 4) {
                                this.selectNode.industrytaxBreakSpecialNode.id = this.tagSpecialData.tags.t4[0].id
                            } else if (this.tagSpecialData.status.minlock === 5) {
                                this.selectNode.industrytaxBreakSpecialNode.id = this.tagSpecialData.tags.t5[0].id
                            }
                        }
                    }
                    break;
            }
        },
        generalLayerChange(value) {
            console.log('search.type:' + this.searchType)
            this.setDefaultTagId()
            this.tagpc.general = value
            this.isFilter = true
            let condition = this.$refs.complexNextSearchBar.getNextCondition()
            if (condition) {
                this.formCommonSearch.da = condition.time
                this.formCommonSearch.text2 = condition.text
            }
            this.goComplexNextSearch()
            //this.complexNextSearch()
        },
        commonLayerChange(value) {
            // console.log(this.tagCommonData) //应答的数据
            console.log('search.type:' + this.searchType)
            this.setDefaultTagId('common')
            this.tagpc.common = value
            this.isFilter_Common = true
            let condition = this.$refs.commonNextSearchBar.getNextCondition()
            this.goCommonNextSearch(condition)
            //this.commonNextSearch()
        },
        specialLayerChange(value) {
            console.log('search.type:' + this.searchType)
            this.setDefaultTagId('special')
            this.tagpc.special = value
            this.isFilter_Special = true
            let condition = this.$refs.specialNextSearchBar.getNextCondition()
            this.goSpecialNextSearch(condition)
            //this.specialNextSearch()
        },
        cleanTagpc() {
            this.tagpc.general = []
            this.tagpc.common = []
            this.tagpc.special = []
        },
        onProgressCancel() {

        },
        onProgressOK() {
            // if (this.uploadpercent === 100 || this.isPollingStop) {
            //     this.isPollingStop = true
            //     this.isShowProgressBox = false
            // } else {
            //     this.showDialog2()
            // }
            this.isPollingStop = true
            this.isShowProgressBox = false
        },
        // onProgressCancel() {
        //     this.isPollingStop = true
        //     this.isShowProgressBox = false
        // },
        // onProgressOK() {
        //     console.log("onProgressOK...")
        //     this.isPollingStop = true
        //     this.isShowProgressBox = false
        // },
        searchDataClear() {
            this.userSearchData.industry.common_da = []
            this.userSearchData.industry.common_text2 = ""
            this.userSearchData.industry.special_da = []
            this.userSearchData.industry.special_text2 = ""

            this.userSearchData.treaty.common_da = []
            this.userSearchData.treaty.common_text2 = ""
            this.userSearchData.treaty.special_da = []
            this.userSearchData.treaty.special_text2 = ""

            this.userSearchData.industrytaxbreak.common_da = []
            this.userSearchData.industrytaxbreak.common_text2 = ""
            this.userSearchData.industrytaxbreak.special_da = []
            this.userSearchData.industrytaxbreak.special_text2 = ""
            //移除tag（已选择的法规分类）
            this.clearAllSelectedTag()
        },
        clearAllSelectedTag() {
            console.log("clearAllSelectedTag........")
            this.selectNode.complexNode = {}
            this.selectNode.complexNode = {}
            this.selectNode.industryCommonNode = {}
            this.selectNode.industrySpecialNode = {}
            this.selectNode.treatyCommonNode = {}
            this.selectNode.treatySpecialNode = {}
            this.selectNode.taxBreakNode_item = {}
            this.selectNode.taxBreakNode_taxes = {}
            this.selectNode.tradeNode = {}
            this.selectNode.industrytaxBreakCommonNode = {}
            this.selectNode.industrytaxBreakSpecialNode = {}
        },
        tagGeneralTipsClose() {
            this.$refs.generalTag.tipClose()
        },
        onGeneralSubmitChecked(folderid) {
            //提交General数据用户已选择的文件

            let count = this.$refs.general_search_rlt.showListTotal()
            let checked = this.$refs.general_search_rlt.getDocIdChecked()
            if (checked.length > 0) {
                this.upLoadFileToCloud(checked, folderid)
            } else {
                this.$Message.warning("没有选择文件")
            }
            //this.$Message.success("提交成功(" + count + ")")
            this.clearCheckList()
            //还原generalbar状态
            this.isGeneralNextBarShow = true
        },
        onCommonSubmitChecked(folderid) {
            //提交Common数据用户已选择的文件

            let count = this.$refs.search_rlt_common.showListTotal()
            let checked = this.$refs.search_rlt_common.getDocIdChecked()
            if (checked.length > 0) {
                this.upLoadFileToCloud(checked, folderid)
            } else {
                this.$Message.warning("没有选择文件")
            }
            //this.$Message.success("提交成功(" + count + ")")
            this.clearCommonCheckList()
            //还原commonNextSearchBar状态
            this.isCommonNextBarShow = true
        },
        onSpecialSubmitChecked(folderid) {
            //提交Common数据用户已选择的文件

            let count = this.$refs.search_rlt_special.showListTotal()
            let checked = this.$refs.search_rlt_special.getDocIdChecked()
            if (checked.length > 0) {
                this.upLoadFileToCloud(checked, folderid)
            } else {
                this.$Message.warning("没有选择文件")
            }
            //this.$Message.success("提交成功(" + count + ")")
            this.clearSpecialCheckList()
            //还原SpecialNextSearchBar状态
            this.isSpecialNextBarShow = true
        },
        clearCheckList() {
            this.$refs.general_search_rlt.clearChkList()
        },
        clearCommonCheckList() {
            this.$refs.search_rlt_common.clearChkList()
        },
        clearSpecialCheckList() {
            this.$refs.search_rlt_special.clearChkList()
        },
        tableRowChecked(listCount) {
            this.$refs.generalTag.showBtnTxt(listCount)
        },
        tableCommonRowChecked(listCount) {
            this.$refs.tableTag_common.showBtnTxt(listCount)
        },
        tableSpecialRowChecked(listCount) {
            this.$refs.tableTag_special.showBtnTxt(listCount)
        },
        showChkBox(value) {
            //console.log(".11111..")
            this.$refs.general_search_rlt.showCheckBox(value)
        },
        showCommonTableChkBox(value) {
            this.$refs.search_rlt_common.showCheckBox(value)
        },
        showSpecialChkBox(value) {
            this.$refs.search_rlt_special.showCheckBox(value)
        },
        expand() {
            this.vaule1 = ["1", "2"];
            this.reload();

        },
        setstatus(data) {

        },
        fliterHeader(obj) {
            this.$refs.search_rlt.reloadHeaderData(obj);
        },
        setmsgpad() {
            this.$refs.treatengine01.setSmallPadLeft();
        },
        getSpecialProvisionData() {
            return testData;
        },
        getSpecialProvisionData2() {
            return testData2;
        },
        getTableData() {
            return tableData;
        },
        getIndustryData(node) {
            if (node === 0) {
                node = { "data": [{ "label": "进出口税收管理类", "id": "001" }] }
            }
            return node
        },
        getProvince() {
            return TagCityData
        },

        childTagChange(node) {
            console.log("childTagChange request node=====>" + node.id)
            console.log(this.getVersion)
            //console.log("search type=====>" + searchType)
            /////////this.currentNode = node
            console.log(this.formCommonSearch)
            this.tagpc.general = this.$refs.generalTag.getLayerData()
            this.isFilter = true
            if (this.searchType === 1) {
                this.selectNode.complexNode = node
                this.handle_GetGeneralFiles(1, this.formCommonSearch, node.id)
            } else if (this.searchType === 2) {
                // this.selectNode.industrySpecialNode=node
                // this.handle_GetIndustryFiles(1, this.formSearchData, node.id)
            } else if (this.searchType === 3) {
                // this.selectNode.treatySpecialNode=node
                // this.handle_GetTreatyFiles(1, this.formSearchData, node.id)
            } else if (this.searchType === 4) {
                this.selectNode.tradeNode = node
                this.handle_GetTradeFiles(1, this.formCommonSearch, node.id)
            } else if (this.searchType === 5) {
                this.selectNode.taxBreakNode_item = node
                this.handle_GetTaxBreakFiles_item(1, this.formCommonSearch, node.id)
            } else if (this.searchType === 6) {
                this.selectNode.taxBreakNode_taxes = node
                this.handle_GetTaxBreakFiles_taxes(1, this.formCommonSearch, node.id)
            }
        },

        childCommondTagChange(node) {
            console.log("commond tag node=====>" + node.id)
            console.log(this.userSearchData.industry)
            //this.currentNode = node
            this.tagpc.common = this.$refs.tableTag_common.getLayerData()
            this.isFilter_Common = true
            if (this.searchType === 2) {

                //处理公共变量被与实际查询条件变量不一致的的情形
                if (this.userSearchData.industry.common_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.industry.common_da
                }
                if (this.userSearchData.industry.common_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.industry.common_text2
                }

                this.selectNode.industryCommonNode = node
                this.handle_GetIndustryCommonFiles(1, this.formSearchData, node.id)
            } else if (this.searchType === 3) {

                //处理公共变量被与实际查询条件变量不一致的的情形
                if (this.userSearchData.treaty.common_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.treaty.common_da
                }
                if (this.userSearchData.treaty.common_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.treaty.common_text2
                }

                this.selectNode.treatyCommonNode = node
                this.handle_GetTreatyCommonFiles(1, this.formSearchData, node.id)
            } else if (this.searchType === 7) {

                //处理公共变量被与实际查询条件变量不一致的的情形

                if (this.userSearchData.industrytaxbreak.common_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.industrytaxbreak.common_da
                }
                if (this.userSearchData.industrytaxbreak.common_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.industrytaxbreak.common_text2
                }
                this.selectNode.industrytaxBreakCommonNode = node
                this.handle_GetTaxBreakIndustryCommonFiles(1, this.formSearchData, node.id)

            }

        },
        childSpecialTagChange(node) {
            console.log("childSpecialTagChange...")
            console.log("this.searchType:" + this.searchType)
            console.log(node)
            this.tagpc.special = this.$refs.tableTag_special.getLayerData()
            this.isFilter_Special = true
            if (this.searchType === 2) {

                //处理公共变量被与实际查询条件变量不一致的的情形
                if (this.userSearchData.industry.special_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.industry.special_da
                }
                if (this.userSearchData.industry.special_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.industry.special_text2
                }
                this.selectNode.industrySpecialNode = node
                this.handle_GetIndustryFiles(1, this.formSearchData, node.id)
            } else if (this.searchType === 3) {

                //处理公共变量被与实际查询条件变量不一致的的情形
                if (this.userSearchData.treaty.special_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.treaty.special_da
                }
                if (this.userSearchData.treaty.special_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.treaty.special_text2
                }

                this.selectNode.treatySpecialNode = node
                this.handle_GetTreatyFiles(1, this.formSearchData, node.id)
            } else if (this.searchType === 7) {

                //处理公共变量被与实际查询条件变量不一致的的情形
                console.log("special:" + this.userSearchData.industrytaxbreak.special_text2)
                if (this.userSearchData.industrytaxbreak.special_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.industrytaxbreak.special_da
                }
                if (this.userSearchData.industrytaxbreak.special_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.industrytaxbreak.special_text2
                }

                this.selectNode.industrytaxBreakSpecialNode = node
                this.handle_GetTaxBreakIndustryFiles(1, this.formSearchData, node.id)
            }
        },
        onSpecialSelectedUploadReady() {
            this.isSpecialNextBarShow = false
        },
        onCommonSelectedUploadReady() {
            this.isCommonNextBarShow = false
        },
        onGeneralSelectedUploadReady() {
            this.isGeneralNextBarShow = false
        },
        //一键上传
        onGeneralOneKeyUpload(folderid) {
            console.log("综合检索一键上传..." + folderid)
            console.log(this.formCommonSearch)
            this.isFilter = true
            if (this.searchType === 1) {
                this.handle_OneKey_GeneralFiles(this.formCommonSearch, this.selectNode.complexNode.id, folderid)
            } else if (this.searchType === 4) {
                this.handle_OneKey_InOutFiles(this.formCommonSearch, this.selectNode.tradeNode.id, folderid)
            } else if (this.searchType === 5) {
                this.handle_OneKey_TaxBreakFiles_item(this.formCommonSearch, this.selectNode.taxBreakNode_item.id, folderid)
            } else if (this.searchType === 6) {
                this.handle_OneKey_TaxBreakFiles_taxes(this.formCommonSearch, this.selectNode.taxBreakNode_taxes.id, folderid)
            }
        },

        //一键上传通用
        onCommonOneKeyUpload(folderid) {
            console.log("通用一键上传..." + folderid)
            this.isFilter_Common = true
            if (this.searchType === 2) {
                this.handle_OneKey_Industry_CommonFiles(this.formSearchData, this.selectNode.industryCommonNode.id, folderid)
            } else if (this.searchType === 3) {
                this.handle_OneKey_Treaty_CommonFiles(this.formSearchData, this.selectNode.industrySpecialNode.id, folderid)
            } else if (this.searchType === 7) {
                this.handle_OneKey_TaxBreakFiles_common(this.formSearchData, this.selectNode.industrytaxBreakCommonNode.id, folderid)
            }
        },
        //一键上传专属
        onSpecialOneKeyUpload(folderid) {
            console.log("专属一键上传..." + folderid)
            console.log(this.searchType)
            this.isFilter_Special = true
            if (this.searchType === 2) {
                this.handle_OneKey_Industry_SpecialFiles(this.formSearchData, this.selectNode.industrySpecialNode.id, folderid)
            } else if (this.searchType === 3) {
                this.handle_OneKey_Treaty_SpecialFiles(this.formSearchData, this.selectNode.industrySpecialNode.id, folderid)
            } else if (this.searchType === 7) {
                console.log("handle_OneKey_TaxBreakFiles_special...")
                this.handle_OneKey_TaxBreakFiles_special(this.formSearchData, this.selectNode.industrytaxBreakSpecialNode.id, folderid)
            }
        },

        //初次通用检索重置状态
        resetFirst() {
            this.isFirstSearch_Common = true
            this.isFirstSearch_Special = true
            this.isFilter_Common = false
            this.isFilter_Special = false
        },
        resetFirst_general() {
            this.isFirstSearch = true
            this.isFilter = false
        },

        //单个结果的二次检索
        goComplexNextSearch() {
            if (this.searchType === 1) {
                this.globalSearch(this.formCommonSearch, this.selectNode.complexNode.id)
            } else if (this.searchType === 4) {
                this.tradeSearch(this.formCommonSearch, this.selectNode.tradeNode.id)
            } else if (this.searchType === 5) {
                //二次查询
                //console.log(condition)
                this.taxBreakSearch(this.formCommonSearch, this.selectNode.taxBreakNode_item.id)
            } else if (this.searchType === 6) {
                //二次查询
                //console.log(condition)
                this.taxBreakSearch(this.formCommonSearch, this.selectNode.taxBreakNode_taxes.id)
            }
        },

        resetGeneralTagNode() {
            this.selectNode.complexNode = {}
            this.selectNode.taxBreakNode_item = {}
            this.selectNode.taxBreakNode_taxes = {}
            this.selectNode.tradeNode = {}
        },
        resetCommonTagNode() {
            this.selectNode.industryCommonNode = {}
            this.selectNode.treatyCommonNode = {}
            this.selectNode.industrytaxBreakCommonNode = {}
        },
        resetSpecialTagNode() {
            this.selectNode.industrySpecialNode = {}
            this.selectNode.treatySpecialNode = {}
            this.selectNode.industrytaxBreakSpecialNode = {}
        },

        //二次查询的时间参数是否为空
        //为空返回true,不为空返回false
        isTimeNullOrEmpty(value) {
            let rlt = false
            console.log(value)
            if (value.time.length === 0 && value.text === "") {
                rlt = true
            } else if (value.time.length === 2 && value.time[0] === "" && value.time[1] === "" && value.text === "") {
                rlt = true
            }
            console.log(rlt)
            return rlt
        },

        // isFilterNotEmpty() {
        //     let rlt = false
        //     if (this.selectNode.complexNode.id !== "" &&
        //         this.selectNode.complexNode.id !== undefined) {
        //         rlt =true
        //     }
        //     if(this.$refs.generalTag.getLayerData().length>0){
        //         rlt =true
        //     }
        //     console.log(this.$refs.generalTag.getLayerData().length)
        //     return rlt
        // },
        //通用tagchange
        complexNextSearch(condition) {
            console.log('综合二次检索====>')
            //第二次
            //this.isFirstSearch = false
            this.isFilter = false
            //清空general结果的tag
            this.resetGeneralTagNode()
            //清空layer
            this.tagpc.general = []
            //console.log(condition)
            if (condition) {
                this.formCommonSearch.da = condition.time
                this.formCommonSearch.text2 = condition.text
            }
            if (this.isTimeNullOrEmpty(condition)) {
                this.isFirstSearch = true
            } else {
                this.isFirstSearch = false
            }

            // if (this.isFilterNotEmpty()) {
            //     //this.isFilter = true
            //     //this.tagpc.general = this.$refs.generalTag.getLayerData()
            // }

            //获取taglayser数据
            // if(this.tagpc.general && this.tagpc.general.length===0){
            //     let r = this.$refs.generalTag.getLayerData()
            //     console.log(r.length)
            //     this.tagpc.general=r
            // }

            this.goComplexNextSearch()

        },

        //多个结果-通用
        goCommonNextSearch(condition) {
            if (this.searchType === 2) {
                //行业检索
                if (condition) {
                    this.userSearchData.industry.common_da = condition.time
                    this.userSearchData.industry.common_text2 = condition.text
                }
                this.formSearchData.da = this.userSearchData.industry.common_da
                this.formSearchData.text2 = this.userSearchData.industry.common_text2
                this.handle_GetIndustryCommonFiles(1, this.formSearchData, this.selectNode.industryCommonNode.id)
            } else if (this.searchType === 3) {
                //条约检索
                if (condition) {
                    this.userSearchData.treaty.common_da = condition.time
                    this.userSearchData.treaty.common_text2 = condition.text
                }
                this.formSearchData.da = this.userSearchData.treaty.common_da
                this.formSearchData.text2 = this.userSearchData.treaty.common_text2
                this.handle_GetTreatyCommonFiles(1, this.formSearchData, this.selectNode.treatyCommonNode.id)

            } else if (this.searchType === 7) {
                //行业检索
                if (condition) {
                    this.userSearchData.industrytaxbreak.common_da = condition.time
                    this.userSearchData.industrytaxbreak.common_text2 = condition.text
                }
                this.formSearchData.da = this.userSearchData.industrytaxbreak.common_da
                this.formSearchData.text2 = this.userSearchData.industrytaxbreak.common_text2
                this.handle_GetTaxBreakIndustryCommonFiles(1, this.formSearchData, this.selectNode.industrytaxBreakCommonNode.id)
            }
        },

        goSpecialNextSearch(condition) {
            if (this.searchType === 2) {
                //行业检索
                if (condition) {
                    this.userSearchData.industry.special_da = condition.time
                    this.userSearchData.industry.special_text2 = condition.text
                }
                this.formSearchData.da = this.userSearchData.industry.special_da
                this.formSearchData.text2 = this.userSearchData.industry.special_text2
                this.handle_GetIndustryFiles(1, this.formSearchData, this.selectNode.industrySpecialNode.id)
            } else if (this.searchType === 3) {
                //条约检索
                if (condition) {
                    this.userSearchData.treaty.special_da = condition.time
                    this.userSearchData.treaty.special_text2 = condition.text
                }
                this.formSearchData.da = this.userSearchData.treaty.special_da
                this.formSearchData.text2 = this.userSearchData.treaty.special_text2
                this.handle_GetTreatyFiles(1, this.formSearchData, this.selectNode.treatySpecialNode.id)

            } else if (this.searchType === 7) {
                //行业检索
                if (condition) {
                    this.userSearchData.industrytaxbreak.special_da = condition.time
                    this.userSearchData.industrytaxbreak.special_text2 = condition.text
                }
                this.formSearchData.da = this.userSearchData.industrytaxbreak.special_da
                this.formSearchData.text2 = this.userSearchData.industrytaxbreak.special_text2
                this.handle_GetTaxBreakIndustryFiles(1, this.formSearchData, this.selectNode.industrytaxBreakSpecialNode.id)
            }
        },

        commonNextSearch(condition) {
            console.log("commonNextSearch........")
            //清空common结果的tag
            this.resetCommonTagNode()
            //标识第二次查询
            if (this.isTimeNullOrEmpty(condition)) {
                this.isFirstSearch_Common = true
            } else {
                this.isFirstSearch_Common = false
            }
            this.isFilter_Common = false
            this.goCommonNextSearch(condition)
        },

        specialNextSearch(condition) {
            console.log("specialNextSearch........")
            //清空special结果的tag
            this.resetSpecialTagNode()
            //标识第二次
            if (this.isTimeNullOrEmpty(condition)) {
                this.isFirstSearch_Special = true
            } else {
                this.isFirstSearch_Special = false
            }

            this.isFilter_Special = false
            this.goSpecialNextSearch(condition)
        },

        onGlobalSearch(searchData) {
            //第一次检索
            this.resetFirst_general()
            console.log("onGlobalSearch......")
            console.log("version:" + this.getVersion)
            //console.log(searchData)
            //清空二次查询条件
            this.$refs.complexNextSearchBar.resetCondition()
            this.formCommonSearch.text2 = ""
            this.formCommonSearch.da = []
            this.selectNode.complexNode = {}
            this.cleanTagpc()
            //重置为默认 地/市州级 选中
            if (this.getVersion === "2" && this.$refs.generalTag) {
                this.$refs.generalTag.cityChecked = true
                this.$refs.generalTag.totalChecked = []
            }
            this.globalSearch(searchData)
            this.$emit('on-searchMain-search') //通知上层收缩

        },

        globalSearch(searchData, tagId) {
            this.formCommonSearch = searchData
            this.searchType = 1
            this.handle_GetGeneralFiles(1, this.formCommonSearch, tagId)
            this.searchDefaultDisp = false
            this.nextSearchBarDisplay("single")
            //this.$refs.complexNextSearchBar.display(true)
            //this.isNextSearchDisp=true
            this.value1 = ["1", "5"]
            this.value2 = ["1"]
            this.$emit('onGlobalSearch', this.formCommonSearch)
            this.showSingle(true)
        },

        onSearch(searchData) {
            console.log("onSearch....")
            this.resetFirst() //重置为第一次
            this.searchDataClear()
            this.cleanTagpc()
            this.$refs.commonNextSearchBar.resetCondition()
            this.$refs.specialNextSearchBar.resetCondition()
            this.formSearchData.da = []
            this.formSearchData.text = ""
            this.formSearchData.text2 = ""
            //重置为默认 地/市州级 选中
            if (this.getVersion === "2" && this.$refs.tableTag_common) {
                this.$refs.tableTag_common.cityChecked = true
                this.$refs.tableTag_common.totalChecked = []
            }
            if (this.getVersion === "2" && this.$refs.tableTag_special) {
                this.$refs.tableTag_special.cityChecked = true
                this.$refs.tableTag_special.totalChecked = []
            }
            this.industrySearch(searchData)
            this.$emit('on-searchMain-search')

        },

        industrySearch(searchData) {
            console.log("industrySearch...")
            this.formSearchData = searchData
            this.searchType = 2
            this.specialTagName = "专属规定"
            this.handle_GetIndustryFiles(1, this.formSearchData)
            this.handle_GetIndustryCommonFiles(1, this.formSearchData)
            this.searchDefaultDisp = false
            this.nextSearchBarDisplay("double")
            // this.$refs.commonNextSearchBar.display(true)
            // this.$refs.specialNextSearchBar.display(true)
            this.value1 = ["1", "2"]
            this.value2 = ["1", "2"]
            //this.$emit('onEngineSearch', this.formSearchData)
            this.$emit('onEngineSearch')
            this.showSingle(false)

        },
        onTradeSearch(searchData) {
            //第一次查询
            this.resetFirst_general()
            this.$refs.complexNextSearchBar.resetCondition()
            this.cleanTagpc()
            this.formCommonSearch.text2 = ""
            this.formCommonSearch.da = []
            //重置为默认 地/市州级 选中
            if (this.getVersion === "2" && this.$refs.generalTag) {
                this.$refs.generalTag.cityChecked = true
            }

            this.tradeSearch(searchData)
            this.$emit('on-searchMain-search')

        },
        tradeSearch(searchData, tagId) {
            console.log("tradeSearch....")
            console.log(searchData)
            this.formCommonSearch = searchData
            this.searchType = 4
            this.handle_GetTradeFiles(1, this.formCommonSearch, tagId)
            this.searchDefaultDisp = false
            this.nextSearchBarDisplay("single")
            this.value1 = ["1", "4"]
            this.value2 = ["1"]
            this.$emit('onTradeSearch', '')
            this.showSingle(true)
            // console.log(this.$refs.topResult)
            //this.$refs.topResult.scrollIntoView({behavior: "instant", block: "end", inline: "nearest"})
        },

        onTaxBreakSearch(searchData, t) {
            // console.log(t)
            // console.log(searchData)
            // console.log("taxBreakSearch......")
            this.searchDataClear()
            this.cleanTagpc()
            if (t === 1) {
                //第一次查询重置
                this.resetFirst_general()

                //清空single二次查询条件
                this.$refs.complexNextSearchBar.resetCondition()
                this.formCommonSearch.text2 = ""
                this.formCommonSearch.da = []
                this.searchType = 5 //税收优惠税种
                //重置为默认 地/市州级 选中
                if (this.getVersion === "2" && this.$refs.generalTag) {
                    this.$refs.generalTag.cityChecked = true
                    this.$refs.generalTag.totalChecked = []
                }
            } else if (t === 2) {
                //第一次查询重置
                this.resetFirst_general()
                //清空single二次查询条件
                this.$refs.complexNextSearchBar.resetCondition()
                this.formCommonSearch.text2 = ""
                this.formCommonSearch.da = []
                this.searchType = 6 //税收优惠项目
                //重置为默认 地/市州级 选中
                if (this.getVersion === "2" && this.$refs.generalTag) {
                    this.$refs.generalTag.cityChecked = true
                    this.$refs.generalTag.totalChecked = []
                }
            } else if (t === 3) {
                //第一次查询重置
                this.resetFirst()
                //清空double二次查询条件
                this.$refs.commonNextSearchBar.resetCondition()
                this.$refs.specialNextSearchBar.resetCondition()
                this.formSearchData.da = []
                this.formSearchData.text = ""
                this.formSearchData.text2 = ""
                this.specialTagName = "专属规定"
                this.searchType = 7 //税收优惠行业
                //重置为默认 地/市州级 选中
                if (this.getVersion === "2" && this.$refs.tableTag_common) {
                    this.$refs.tableTag_common.cityChecked = true
                    this.$refs.tableTag_common.totalChecked = []
                }
                if (this.getVersion === "2" && this.$refs.tableTag_special) {
                    this.$refs.tableTag_special.cityChecked = true
                    this.$refs.tableTag_special.totalChecked = []
                }
            }



            this.taxBreakSearch(searchData, '')
            this.$emit('on-searchMain-search')
        },
        taxBreakSearch(searchData, tagId) {
            console.log("taxBreakSearch-searchData...")
            console.log(searchData)
            this.formSearchData = searchData
            //税收优惠行业,搜索结果包含专属和通用
            if (this.searchType === 7) {
                console.log("查询税收优惠行业...")
                //this.searchType = 6
                //this.specialTagName = "专属规定"
                //专属和通用接口
                this.handle_GetTaxBreakIndustryCommonFiles(1, this.formSearchData, tagId)
                this.handle_GetTaxBreakIndustryFiles(1, this.formSearchData, tagId)
                this.searchDefaultDisp = false
                this.nextSearchBarDisplay("double")
                this.value1 = ["1", "6"]
                this.value2 = ["1", "2"]
                this.showSingle(false)
            } else {
                this.formCommonSearch = searchData
                if (this.searchType === 5) {
                    console.log("查询税收优惠税种...")
                    this.handle_GetTaxBreakFiles_taxes(1, this.formCommonSearch, tagId)
                } else if (this.searchType === 6) {
                    console.log("查询税收优惠项目...")
                    this.handle_GetTaxBreakFiles_item(1, this.formCommonSearch, tagId)
                }

                this.searchDefaultDisp = false
                this.nextSearchBarDisplay("single")
                this.value1 = ["1", "6"]
                this.value2 = ["1"]
                this.showSingle(true)
            }
            this.$emit('onTaxBreakSearch')

        },
        onTreatySearch(searchData) {
            //第一次查询重置
            this.resetFirst()

            this.searchDataClear()
            this.cleanTagpc()
            this.$refs.commonNextSearchBar.resetCondition()
            this.$refs.specialNextSearchBar.resetCondition()
            this.formSearchData.da = []
            this.formSearchData.text = ""
            this.formSearchData.text2 = ""
            //重置为默认 地/市州级 选中
            if (this.getVersion === "2" && this.$refs.tableTag_common) {
                this.$refs.tableTag_common.cityChecked = true
                this.$refs.tableTag_common.totalChecked = []
            }
            if (this.getVersion === "2" && this.$refs.tableTag_special) {
                this.$refs.tableTag_special.cityChecked = true
                this.$refs.tableTag_special.totalChecked = []
            }
            this.treatySearch(searchData)
            this.$emit('on-searchMain-search')
        },

        treatySearch(searchData) {
            //console.log(searchData)
            this.formSearchData = searchData
            this.searchType = 3
            this.specialTagName = "国家(地区)"
            this.handle_GetTreatyFiles(1, this.formSearchData)
            this.handle_GetTreatyCommonFiles(1, this.formSearchData)
            this.searchDefaultDisp = false
            this.nextSearchBarDisplay("double")
            this.value1 = ["1", "3"]
            this.value2 = ["1", "2"]
            this.$emit('onTreatySearch', '')
            this.showSingle(false)
        },
        showSingle(b) {
            //this.doubleProvision = b
            if (b) {
                this.singleProvision = true
                this.doubleProvision = false
            } else {
                this.singleProvision = false
                this.doubleProvision = true
            }

        },
        goSearchEngine() {
            this.value1 = ["5"]
        },
        reset() {
            this.value1 = []
            this.value2 = []
        },
        getOneKeyUploadProgress(id) {
            console.log("request progress id:" + id)
            constJ.reqGetOneKey_UploadProgress_V2(id).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        let total = res.item.total
                        let complete = res.item.complete
                        let per = 0
                        if (total > 0) {
                            per = parseInt((complete / total) * 100)
                        } else {
                            this.$Message.error("总计上传条数为零");
                            return
                        }
                        this.uploadpercent = per
                    } else {
                        this.$Message.error(res.rltdesc);
                        this.isShowProgressBox = false
                        this.isPollingStop = true
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    this.isShowProgressBox = false
                    this.isPollingStop = true
                    return
                }
            }).catch(error => {
                if (!error.response) {
                    // network error
                    //this.errorStatus = 'Error: Network Error';

                    // this.isShowProgressBox = false
                    // this.isPollingStop = true
                    if (this.disconnectTimes <= 20) {
                        this.disconnectTimes++;
                    } else {
                        this.uploadTitle = "您的网络连接异常,请勿担心,系统仍然会持续完成文件上传任务"
                        this.titletheme = "#ff9900"
                        this.buttonTheme = 'warning'
                        this.isActiveButton = false
                    }
                    this.$Message.error("网络连接异常");
                } else {
                    this.errorStatus = error.response.data.message;
                    this.isShowProgressBox = false
                    this.isPollingStop = true
                    this.$Message.error(this.errorStatus);
                }
                //console.log( this.errorStatus)
            })
        },
        autoPollingOneKeyProgress(id) {
            //状态初始化
            this.uploadpercent = 0
            this.isPollingStop = false
            this.uploadTitle = "稍候片刻,请静待上传完成"
            this.titletheme = "#2d8cf0"
            this.isActiveButton = true
            this.buttonTheme = "success"
            this.disconnectTimes = 0
            // this.progressBoxButtonText="关闭进度显示"
            let clock = window.setInterval(() => {
                this.getOneKeyUploadProgress(id)
                if (this.uploadpercent === 100 || this.isPollingStop) {
                    this.uploadTitle = "文件上传成功,谢谢您的耐心等待"
                    this.titletheme = "#19be6b"
                    this.isActiveButton = false
                    this.buttonTheme = "success"
                    //this.progressBoxButtonText="确定"
                    console.log("clearInterval...")
                    window.clearInterval(clock)
                }
            }, 1000)
        },
        //综合一键上传
        handle_OneKey_GeneralFiles(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.general.length === 0) {
                    layerData = this.$refs.generalTag.getLayerData()
                } else {
                    layerData = this.tagpc.general
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.general
            }
            var item = {}
            item.text = args.content
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.text2 = args.text2
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch
            item.ft = this.isFilter
            constJ.reqOneKeyGeneralFiles_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }

                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },
        //行业-通用-一键上传
        handle_OneKey_Industry_CommonFiles(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.common.length === 0) {
                    layerData = this.$refs.tableTag_common.getLayerData()
                } else {
                    layerData = this.tagpc.common
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.common
            }
            var item = {}
            item.fname = args.inputfilename
            item.fcode = args.inputnumber
            item.otext = args.inputothers
            item.text2 = args.text2
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.icode = args.industryselected.id
            item.tcode = args.taxcategoryselected.id
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch_Common
            item.ft = this.isFilter_Common
            constJ.reqOneKeyIndustryCommonFiles_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },

        //行业-专属-一键上传
        handle_OneKey_Industry_SpecialFiles(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.special.length === 0) {
                    layerData = this.$refs.tableTag_special.getLayerData()
                } else {
                    layerData = this.tagpc.special
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.special
            }
            var item = {}
            item.fname = args.inputfilename
            item.fcode = args.inputnumber
            item.otext = args.inputothers
            item.text2 = args.text2
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.icode = args.industryselected.id
            item.tcode = args.taxcategoryselected.id
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch_Special
            item.ft = this.isFilter_Special
            constJ.reqOneKeyIndustrySpecialFiles_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },


        //条约-通用-一键上传
        handle_OneKey_Treaty_CommonFiles(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.common.length === 0) {
                    layerData = this.$refs.tableTag_common.getLayerData()
                } else {
                    layerData = this.tagpc.common
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.common
            }
            var item = {}
            item.country = args.country.id !== undefined ? args.country.id : ""
            item.ktext = args.keywordValue
            item.text2 = args.text2
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch_Common
            item.ft = this.isFilter_Special
            constJ.reqOneKeyTreatyCommonFiles_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },
        //条约-专属-一键上传
        handle_OneKey_Treaty_SpecialFiles(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.special.length === 0) {
                    layerData = this.$refs.tableTag_special.getLayerData()
                } else {
                    layerData = this.tagpc.special
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.special
            }
            var item = {}
            item.country = args.country.id !== undefined ? args.country.id : ""
            item.ktext = args.keywordValue
            item.text2 = args.text2
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch_Special
            item.ft = this.isFilter_Special
            constJ.reqOneKeyTreatySpecialFiles_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },

        //优惠项目一键上传
        handle_OneKey_TaxBreakFiles_item(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.general.length === 0) {
                    layerData = this.$refs.generalTag.getLayerData()
                } else {
                    layerData = this.tagpc.general
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.general
            }
            var item = {}
            item.text = args.content
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.kcode = args.categoryselected.id !== undefined ? args.categoryselected.id : ""
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.text2 = args.text2
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch
            item.ft = this.isFilter
            constJ.reqOneKeyTaxBreakFiles_item_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },

        //优惠税种一键上传
        handle_OneKey_TaxBreakFiles_taxes(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.general.length === 0) {
                    layerData = this.$refs.generalTag.getLayerData()
                } else {
                    layerData = this.tagpc.general
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.general
            }
            var item = {}
            item.text = args.content
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.kcode = args.categoryselected.id !== undefined ? args.categoryselected.id : ""
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.text2 = args.text2
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch
            item.ft = this.isFilter
            constJ.reqOneKeyTaxBreakFiles_taxes_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },

        //优惠行业一键上传-通用
        handle_OneKey_TaxBreakFiles_common(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.common.length === 0) {
                    layerData = this.$refs.tableTag_common.getLayerData()
                } else {
                    layerData = this.tagpc.common
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.common
            }
            var item = {}
            item.text = args.content
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.kcode = args.categoryselected.id !== undefined ? args.categoryselected.id : ""
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.text2 = args.text2
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch_Common
            item.ft = this.isFilter_Common
            constJ.reqOneKeyTaxBreakFiles_common_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },

        //优惠行业一键上传-专属
        handle_OneKey_TaxBreakFiles_special(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.special.length === 0) {
                    layerData = this.$refs.tableTag_special.getLayerData()
                } else {
                    layerData = this.tagpc.special
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.special
            }
            var item = {}
            item.text = args.content
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.kcode = args.categoryselected.id !== undefined ? args.categoryselected.id : ""
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.text2 = args.text2
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch_Special
            item.ft = this.isFilter_Special
            constJ.reqOneKeyTaxBreakFiles_special_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },

        //进出口一键上传
        handle_OneKey_InOutFiles(args, tagid, folderid) {
            var layerData = []
            if (this.getVersion === "2") {
                if (this.tagpc && this.tagpc.general.length === 0) {
                    layerData = this.$refs.generalTag.getLayerData()
                } else {
                    layerData = this.tagpc.general
                }
            } else if (this.getVersion === "1") {
                layerData = this.defaultTagpc.general
            }
            var item = {}
            item.fname = args.inputfilename
            item.fcode = args.inputnumber
            item.ktext = args.inputothers
            item.text2 = args.text2
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.kcode = args.categoryselected.id !== undefined ? args.categoryselected.id : ""
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.dirid = folderid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = layerData
            item.fs = this.isFirstSearch
            item.ft = this.isFilter
            constJ.reqOneKeyInoutFiles_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //启动定时器
                        //this.autoPollingOneKeyProgress()
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },


        upLoadFileToCloud(idList, folderid) {
            // let docids=[]
            // docids.push(parseInt(this.text))
            console.log(idList, folderid)
            constJ.upLoadFileToCloud(idList, folderid).then(res => {
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$Message.success("已上传" + idList.length + "个文件至云端")
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },

        handle_GetGeneralFiles(currentIndex, args, tagid) {
            console.log('handle_GetGeneralFiles=============>')
            var item = {}
            item.text = args.content
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.text2 = args.text2
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch
            item.ft = this.isFilter

            constJ.reqGetGeneralFiles(this.psize, currentIndex, item).then(res => {
                console.log(res)
                if (res.rltcode === 1) {
                    if (res.rtncode === 1) {
                        var obj = null
                        if (res.tbls.length > 0) {
                            obj = {
                                header: testData2.header,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                tabname: "general",
                                tags: res.tbls[0].classifytag,
                                level: res.tbls[0].divisiontag,
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                                index: currentIndex,
                            }
                        } else {
                            //默认
                            obj = {
                                header: testData2.header,
                                tabrows: null,
                                total: 0,
                                tabname: "general",
                                tags: res.tbls[0].classifytag,
                                level: null,
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                                index: currentIndex,
                            }
                        }
                        this.$refs.general_search_rlt.show(obj)
                        //this.$refs.generalTag.layerDisable(false)
                        //绑定tag
                        var _obj = MoreFun.getTag(obj.tags)
                        var tempTag = {
                            tags: _obj,
                            status: obj.tagstatus,
                            total: obj.total,
                            level: obj.level,
                            warninglevel: obj.warninglevel,
                            warningtext: obj.warningtext,
                            protect: res.tbls[0].protect,
                        }
                        this.tagData = tempTag
                        this.flag = true
                        console.log(this.tagData)
                    } else {
                        this.$Message.error(res.rtncode)
                        console.log(res.rtncode)
                        return
                    }
                } else {
                    this.$Message.error(res.rltcode)
                    console.log(res.rltcode)
                    return
                }



            }).catch(err => {
                console.log(err)
            })
        },


        handle_GetIndustryFiles(currentIndex, args, tagid) {
            var item = {}
            item.fname = args.inputfilename
            item.fcode = args.inputnumber
            item.otext = args.inputothers
            item.text2 = args.text2
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.icode = args.industryselected.id
            item.tcode = args.taxcategoryselected.id
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch_Special
            item.ft = this.isFilter_Special

            constJ.reqGetIndustryFiles(this.psize, currentIndex, item).then(res => {
                console.log(res)
                var obj = null
                if (res.tbls.length > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        tabname: "industy",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                } else {
                    //默认
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        tabname: "industy",
                        tags: res.tbls[0].classifytag,
                        level: null,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                }
                this.$refs.search_rlt_special.show(obj)
                //绑定tag1
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }
                this.tagSpecialData = tempTag
                this.isShowSpecialTag = true
            }).catch(err => {
                console.log(err)
            })
        },

        handle_GetIndustryCommonFiles(currentIndex, args, tagid) {
            var item = {}
            item.fname = args.inputfilename
            item.fcode = args.inputnumber
            item.otext = args.inputothers
            item.text2 = args.text2
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.icode = args.industryselected.id
            item.tcode = args.taxcategoryselected.id
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch_Common
            item.ft = this.isFilter_Common

            constJ.reqGetIndustryCommonFiles(this.psize, currentIndex, item).then(res => {
                console.log(res)
                var obj = null
                if (res.tbls.length > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        tabname: "industycommon",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                } else {
                    //默认
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        tabname: "industycommon",
                        tags: res.tbls[0].classifytag,
                        level: null,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                }
                this.$refs.search_rlt_common.show(obj)
                //绑定tag1
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }
                this.tagCommonData = tempTag
                this.isShowCommonTag = true
            }).catch(err => {
                console.log(err)
            })
        },

        handle_GetTreatyFiles(currentIndex, args, tagid) {
            var item = {}
            item.country = args.country.id !== undefined ? args.country.id : ""
            item.ktext = args.keywordValue
            item.text2 = args.text2
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch_Special
            item.ft = this.isFilter_Special
            constJ.reqGetTreatyFiles(this.psize, currentIndex, item).then(res => {
                console.log(res)
                var obj = null
                if (res.tbls.length > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        tabname: "treaty",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                        showColumns: MoreFun.getColumns().treaty
                        //showColumns:['chk', 'docid', 'fname','pdate', 'publisher', 'potence'],
                    }
                } else {
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        tabname: "treaty",
                        tags: res.tbls[0].classifytag,
                        level: null,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                        showColumns: [],
                    }
                }
                this.$refs.search_rlt_special.show(obj)
                //绑定tag
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }
                this.tagSpecialData = tempTag
                this.isShowSpecialTag = true
                //this.flag = true
            }).catch(err => {
                console.log(err)
            })
        },

        handle_GetTreatyCommonFiles(currentIndex, args, tagid) {
            var item = {}
            item.country = args.country.id !== undefined ? args.country.id : ""
            item.ktext = args.keywordValue
            item.text2 = args.text2
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch_Common
            item.ft = this.isFilter_Common

            constJ.reqGetCommonTreatyFiles(this.psize, currentIndex, item).then(res => {
                console.log(res)
                var obj = null
                if (res.tbls.length > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        tabname: "treatycommon",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                } else {
                    //默认
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        tabname: "treatycommon",
                        tags: res.tbls[0].classifytag,
                        level: null,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                }
                this.$refs.search_rlt_common.show(obj)
                //绑定tag1
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }
                this.tagCommonData = tempTag
                this.isShowCommonTag = true
            }).catch(err => {
                console.log(err)
            })
        },



        handle_GetTradeFiles(currentIndex, args, tagid) {
            var item = {}
            item.fname = args.inputfilename
            item.fcode = args.inputnumber
            item.ktext = args.inputothers
            item.text2 = args.text2
            item.stime = args.da === undefined ? "" : args.da[0]
            item.etime = args.da === undefined ? "" : args.da[1]
            item.kcode = args.categoryselected !== undefined ? args.categoryselected.id : ""
            item.potence = args.fileforce !== undefined ? args.fileforce.id : ""
            item.tagid = tagid
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch
            item.ft = this.isFilter
            //let day = moment(args.date[0])
            //console.log(day.startOf("day").format("YYYY-MM-DD HH:mm:ss"))
            //console.log(day.endOf("day").format("YYYY-MM-DD HH:mm:ss"))
            //console.log(day.format("YYYY-MM-DD HH-mm-ss"))
            //console.log(item)
            constJ.reqGetInOutFiles(this.psize, currentIndex, item).then(res => {
                console.log(res)
                var obj = null
                if (res.tbls.length > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        tabname: "trade",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                } else {
                    //默认
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        tabname: "trade",
                        tags: res.tbls[0].classifytag,
                        level: null,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                }
                this.$refs.general_search_rlt.show(obj)
                //绑定tag
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }
                this.tagData = tempTag
                this.flag = true





            }).catch(err => {
                console.log(err)
            })
        },
        //税收优惠项目或税收优惠税种
        handle_GetTaxBreakFiles_item(currentIndex, args, tagid) {

            var item = {}
            item.text = args.content
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.kcode = args.categoryselected.id !== undefined ? args.categoryselected.id : ""
            // item.stime = args.time[0]
            // item.etime = args.time[1]
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.text2 = args.text2
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch
            item.ft = this.isFilter

            constJ.reqGetTaxBreakFiles_item(this.psize, currentIndex, item).then(res => {
                console.log(res)
                var obj = null
                if (res.tbls.length > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        tabname: "taxbreak_item",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                } else {
                    //默认
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        tabname: "taxbreak_item",
                        tags: res.tbls[0].classifytag,
                        level: null,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                }
                this.$refs.general_search_rlt.show(obj)
                //绑定tag
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }
                this.tagData = tempTag
                this.flag = true
                console.log(this.tagData)
            }).catch(err => {
                console.log(err)
            })
        },

        //税收优惠税种
        handle_GetTaxBreakFiles_taxes(currentIndex, args, tagid) {

            var item = {}
            item.text = args.content
            item.stime = args.da[0]
            item.etime = args.da[1]
            item.kcode = args.categoryselected.id !== undefined ? args.categoryselected.id : ""
            // item.stime = args.time[0]
            // item.etime = args.time[1]
            item.potence = args.fileforce.id
            item.tagid = tagid
            item.text2 = args.text2
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch
            item.ft = this.isFilter

            constJ.reqGetTaxBreakFiles_taxes(this.psize, currentIndex, item).then(res => {
                console.log(res)
                var obj = null
                if (res.tbls.length > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        tabname: "taxbreak_taxes",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                } else {
                    //默认
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        tabname: "taxbreak_taxes",
                        tags: res.tbls[0].classifytag,
                        level: null,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                }
                this.$refs.general_search_rlt.show(obj)
                //绑定tag
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }
                this.tagData = tempTag
                this.flag = true
                console.log(this.tagData)
            }).catch(err => {
                console.log(err)
            })
        },

        //税收优惠行业通用
        handle_GetTaxBreakIndustryCommonFiles(currentIndex, args, tagid) {
            console.log("handle_GetTaxBreakIndustryCommonFiles....")
            console.log(args)
            var item = {}
            item.text = args.content
            item.stime = args.da === undefined ? '' : args.da[0]
            item.etime = args.da === undefined ? '' : args.da[1]
            item.kcode = args.categoryselected !== undefined ? args.categoryselected.id : ""
            item.potence = args.categoryselected !== undefined ? args.fileforce.id : ""
            item.tagid = tagid
            item.text2 = args.text2
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch_Common
            item.ft = this.isFilter_Common

            constJ.reqGetTaxBreakIndustryCommonFiles(this.psize, currentIndex, item).then(res => {
                console.log(res)
                var obj = null
                if (res.tbls.length > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        tabname: "taxbreakcommon",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                } else {
                    //默认
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        tabname: "taxbreakcommon",
                        tags: res.tbls[0].classifytag,
                        level: null,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                }
                this.$refs.search_rlt_common.show(obj)
                //绑定tag
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }
                this.tagCommonData = tempTag
                this.isShowCommonTag = true
            }).catch(err => {
                console.log(err)
            })
        },

        //税收优惠行业专属
        handle_GetTaxBreakIndustryFiles(currentIndex, args, tagid) {

            var item = {}
            item.text = args.content
            // item.stime = args.da[0]
            // item.etime = args.da[1]
            // item.kcode = args.categoryselected.id !== undefined ? args.categoryselected.id : ""
            // item.potence = args.fileforce.id
            item.stime = args.da === undefined ? '' : args.da[0]
            item.etime = args.da === undefined ? '' : args.da[1]
            item.kcode = args.categoryselected !== undefined ? args.categoryselected.id : ""
            item.potence = args.categoryselected !== undefined ? args.fileforce.id : ""
            item.tagid = tagid
            item.text2 = args.text2
            item.ps = this.getVersion === "2" ? this.defaultpc : {}
            item.tagpc = this.getVersion === "2" ? this.tagpc : this.defaultTagpc
            item.fs = this.isFirstSearch_Special
            item.ft = this.isFilter_Special

            constJ.reqGetTaxBreakIndustryFiles(this.psize, currentIndex, item).then(res => {
                console.log(res)
                var obj = null
                if (res.tbls.length > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        tabname: "taxbreakspecial",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                } else {
                    //默认
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        tabname: "taxbreakspecial",
                        tags: res.tbls[0].classifytag,
                        level: null,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                    }
                }
                this.$refs.search_rlt_special.show(obj)
                //绑定tag
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel: obj.warninglevel,
                    warningtext: obj.warningtext,
                    protect: res.tbls[0].protect,
                }

                this.tagSpecialData = tempTag
                this.isShowSpecialTag = true
            }).catch(err => {
                console.log(err)
            })
        },


        pageChange(index, tabName) {
            console.log("pageChange,index:" + index + ",tabName:" + tabName)
            console.log(this.formSearchData)
            if (tabName === "general") {
                this.handle_GetGeneralFiles(index, this.formCommonSearch, this.selectNode.complexNode.id)
            } else if (tabName === "industy") {
                //处理公共变量被与实际查询条件变量不一致的的情形
                if (this.userSearchData.industry.special_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.industry.special_da
                }
                if (this.userSearchData.industry.special_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.industry.special_text2
                }
                this.handle_GetIndustryFiles(index, this.formSearchData, this.selectNode.industrySpecialNode.id)
            } else if (tabName === "industycommon") {
                //处理公共变量被与实际查询条件变量不一致的的情形
                if (this.userSearchData.industry.common_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.industry.common_da
                }
                if (this.userSearchData.industry.common_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.industry.common_text2
                }
                this.handle_GetIndustryCommonFiles(index, this.formSearchData, this.selectNode.industryCommonNode.id)
            } else if (tabName === "treaty") {
                //处理公共变量被与实际查询条件变量不一致的的情形
                if (this.userSearchData.treaty.special_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.treaty.special_da
                }
                if (this.userSearchData.treaty.special_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.treaty.special_text2
                }
                this.handle_GetTreatyFiles(index, this.formSearchData, this.selectNode.treatySpecialNode.id)
            } else if (tabName === "treatycommon") {
                if (this.userSearchData.treaty.common_da.length === 0) {
                    this.formSearchData.da = []
                } else {
                    this.formSearchData.da = this.userSearchData.treaty.common_da
                }
                if (this.userSearchData.treaty.common_text2 === "") {
                    this.formSearchData.text2 = ""
                } else {
                    this.formSearchData.text2 = this.userSearchData.treaty.common_text2
                }
                this.handle_GetTreatyCommonFiles(index, this.formSearchData, this.selectNode.treatyCommonNode.id)
            } else if (tabName === "trade") {
                this.handle_GetTradeFiles(index, this.formCommonSearch, this.selectNode.tradeNode.id)
            } else if (tabName === "taxbreak_item") {
                //税收优惠项目
                //console.log(this.selectNode.taxBreakNode.id)
                this.handle_GetTaxBreakFiles_item(index, this.formCommonSearch, this.selectNode.taxBreakNode_item.id)

            } else if (tabName === "taxbreak_taxes") {
                //税收优惠税种
                //console.log(this.selectNode.taxBreakNode.id)
                this.handle_GetTaxBreakFiles_taxes(index, this.formCommonSearch, this.selectNode.taxBreakNode_taxes.id)

            } else if (tabName === "taxbreakcommon") {
                this.handle_GetTaxBreakIndustryCommonFiles(index, this.formSearchData, this.selectNode.industrytaxBreakCommonNode.id)
            } else if (tabName === "taxbreakspecial") {
                this.handle_GetTaxBreakIndustryFiles(index, this.formSearchData, this.selectNode.industrytaxBreakSpecialNode.id)
            }
        },

        nextSearchBarDisplay(type) {
            if (type === "single") {
                this.$refs.complexNextSearchBar.display(true)
                this.$refs.commonNextSearchBar.display(false)
                this.$refs.specialNextSearchBar.display(false)
            } else if (type === "double") {
                this.$refs.complexNextSearchBar.display(false)
                this.$refs.commonNextSearchBar.display(true)
                this.$refs.specialNextSearchBar.display(true)
            } else {

            }
        }


    },
    mounted: function() {
        this.classid = this.$route.query.classid

        //console.log(this.classid)
        //console.log(this.specialProvisionData)
    },
    watch: {
        sliders: function(v) {
            console.log('sliders:' + v)
            if (this.searchType === 3) {
                this.$refs.general_search_rlt.onSlidersChanged()
                this.$refs.search_rlt_common.onSlidersChanged()
                this.$refs.search_rlt_special.onSlidersChanged(MoreFun.getColumns().treaty)
            } else {
                this.$refs.general_search_rlt.onSlidersChanged()
                this.$refs.search_rlt_common.onSlidersChanged()
                this.$refs.search_rlt_special.onSlidersChanged()
            }

            //this.onSlidersChanged()
        }
    }
    // watch:{
    //  '$route':function(to,from){
    //  }
    // }

}
</script>
<style lang="less" scoped>
.cpllapse-panel-title {
    font-size: 12px;
}
#panelTop1/deep/.ivu-collapse-content>.ivu-collapse-content-box{
    padding-top: 5px;
}
#searchMainTabs/deep/.ivu-tabs-bar{
    margin-bottom: 5px;
}
</style>